import settinginterface from "../interfaces/settinginterface";
import environment from "../environment";

export default {

    data: () => ({
        settingKeys: [],
    }),

    async getUpperBoundsForPools(upperBoundsForPools) {
        await settinginterface.getSettings(keys => {
            this.settingKeys = keys;
        });

        let upperWarningBound = 0;
        let upperErrorBound = 0;


        if (this.settingKeys != null) {
            for (const setting of this.settingKeys) {
                if (setting.key === "UpperWarningBoundForPool") {
                    upperWarningBound = parseInt(setting.value);
                } else if (setting.key === "UpperErrorBoundForPool") {
                    upperErrorBound = parseInt(setting.value);
                }
            }
        }

        let upperBounds = {
            upperWarningBoundForPool: upperWarningBound,
            upperErrorBoundForPool: upperErrorBound
        };

        upperBoundsForPools(upperBounds);
    }
}



// WEBPACK FOOTER //
// ./src/managers/settingmanager.js